import {useMutation} from "@tanstack/react-query";
import {MUTATION_KEYS} from "./queryKeys";
import Api from "../api/Api";
import {overlay} from "../types/marker";


export const useSurfaceMapMutation = () => (
  useMutation({
    mutationKey: [MUTATION_KEYS.map.surfaceMaps],
    mutationFn: async (params: {
      index: number,
      mapBound: number[],
      datasetId: string,
      overlay: overlay
    }) => {
      try {
        return await Api.fileEndPoint.getLayGeoJson(
          params.index,
          params.mapBound,
          params.datasetId,
          params.overlay
        );
      } catch (error) {
        console.error('Error fetching surface map:', error);
        throw error;
      }
    }
}))
